import Admin_Quiz_Analyze from './Admin_Quiz_Analyze'

export default Admin_Quiz_Analyze